import { ChatOutlinedIcon, Flex, Text } from '@shared/components';

export default function EmptyCommentSection() {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        p: (theme) => theme.spacing(6),
        border: (theme) => `1px dashed ${theme.palette.divider}`,
        m: 'auto',
        bgcolor: (theme) => theme.palette.grey[50],
        gap: (theme) => theme.spacing(4),
      }}
    >
      <ChatOutlinedIcon color='secondary' sx={{ fontSize: 48 }} />
      <Text variant='h3'>ยังไม่มีข้อมูลผลการรีวิว</Text>
    </Flex>
  );
}
